import React from 'react';
import {
  Container, Typography, Grid, Card, CardContent, Box, List,
  ListItem, ListItemIcon, ListItemText, Paper, Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhoneIcon from '@mui/icons-material/Phone';
import SettingsPhoneIcon from '@mui/icons-material/SettingsPhone';
import SpeedIcon from '@mui/icons-material/Speed';
import BusinessIcon from '@mui/icons-material/Business';

const services = [
  'VoIP system installation and configuration',
  'Cisco CUCM (Unified Communications Manager) setup',
  'Alcatel 4400 / OXO phone system administration',
  'IP phone deployment and configuration',
  'Call routing and dial plan setup',
  'Extension management and voicemail setup',
  'QoS (Quality of Service) configuration',
  'VoIP system migration and upgrades',
  'IOS upgrades and patch management',
  'VoIP troubleshooting and support',
  'Call control policy implementation',
  'Multi-site VoIP deployment',
];

const benefits = [
  {
    icon: BusinessIcon,
    title: 'Enterprise VoIP',
    description: 'Led enterprise VoIP deployments for 1,000+ and 4,000+ users using Cisco CUCM',
  },
  {
    icon: PhoneIcon,
    title: 'Multi-Platform',
    description: 'Experience with Cisco CUCM, Alcatel 4400/OXO, and modern IP phone systems',
  },
  {
    icon: SettingsPhoneIcon,
    title: 'Full Lifecycle',
    description: 'From installation to IOS upgrades, QoS, and ongoing patch management',
  },
  {
    icon: SpeedIcon,
    title: 'QoS Optimization',
    description: 'Properly configured QoS policies to ensure crystal-clear call quality',
  },
];

function VoipSystems() {
  return (
    <Box sx={{ py: 6, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h2" component="h1" className="gradient-text" sx={{ mb: 3 }}>
            VoIP & Phone Systems
          </Typography>
          <Typography variant="h5" sx={{ color: 'text.secondary', mb: 4 }}>
            Enterprise VoIP installation, configuration, and administration for businesses of all sizes
          </Typography>
          <Button
            component={RouterLink}
            to="/booking"
            variant="contained"
            size="large"
            sx={{
              py: 2, px: 4, fontSize: '1.2rem',
              background: 'linear-gradient(45deg, #2563eb 30%, #3b82f6 90%)',
              '&:hover': { background: 'linear-gradient(45deg, #3b82f6 30%, #2563eb 90%)' }
            }}
          >
            Book Consultation
          </Button>
        </Box>

        <Grid container spacing={4} sx={{ mb: 8 }}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card className="glass-effect card-hover" sx={{ height: '100%' }}>
                <CardContent sx={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <Box sx={{ mb: 2, color: 'primary.main' }}>
                    {React.createElement(benefit.icon, { sx: { fontSize: 40 } })}
                  </Box>
                  <Typography variant="h6" gutterBottom>{benefit.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{benefit.description}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Paper elevation={3} sx={{ p: 4, background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>VoIP Services Offered</Typography>
          <Grid container spacing={2}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <List>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                    <ListItemText primary={service} />
                  </ListItem>
                </List>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}

export default VoipSystems;
